import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { notification } from "antd";
import Modulo from "../_Aux/Modulo";
import { GeralContext } from "../ContextProvider";
import { GlobalContext } from "../../GlobalState";
import axios from "axios";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class Modulos extends Component {
    static contextType = GlobalContext;
    state = {
        cursoid: 0,
        curso: "",
        retomar: {},
        //modulo_aberto: "0",
        modulos: [],
        botoesVisiveis: false,
        total_conteudos: 0,
        total_conteudos_realizados: 0,
        //PERMISSOES
        loading: false,
        //REDIRECT
        redirect: false,
        redirectLink: "",
        //PRESENÇAS
        totalPresencas: 0,
        totalFolhasPresencas: 0
    };

    //CHAMADA ANTES DO RENDER
    UNSAFE_componentWillMount() {
        axios.defaults.timeout = 60 * 10 * 1000;
        var cursoId = localStorage.getItem("codigo_curso");

        this.setState({
            cursoid: cursoId,
            curso: this.props.match.params.curso
        });

        if (this.context.lista_modulos.length === 0) this.listarModulos(cursoId);
        else
            this.setState({
                modulos: this.context.lista_modulos,
                proximaPosicaoModulo: this.context.lista_modulos[this.context.lista_modulos.length - 1].ordem + 1
            });

        //var modulo = this.getParameterByName("modulo");
        //if (this.getParameterByName("modulo"))
        //    this.setState({
        //        modulo_aberto: modulo
        //    });
    }

    //APANHA PARAMETROS PASSADOS PELO URL
    //getParameterByName = name => {
    //    var match = RegExp("[?&]" + name + "=([^&]*)").exec(window.location.search);
    //    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
    //};

    //CARREGA E LISTA TODOS OS MODULOS PERTENCENTES AO CURSO E IDENTIFICA A ULTIMA POSIÇÃO NA ORDEM
    listarModulos = cursoid => {
        this.setState({
            loading: true
        });

        axios({
            method: "get",
            url: "/api/curso-modulo/listar-modulos",
            params: {
                cursoid
            }
        })
            .then(response => {
                if (response.data.length > 0) {
                    this.context.atualizarState({
                        lista_modulos: response.data
                    });

                    this.setState({
                        modulos: response.data,
                        proximaPosicaoModulo: response.data[response.data.length - 1].ordem + 1,
                        loading: false
                    });
                }
                else
                    this.setState({
                        loading: false
                    });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    listarModulo = moduloid => {
        axios({
            method: "get",
            url: "/api/curso-modulo/listar-modulo",
            params: {
                cursoid: localStorage.getItem("codigo_curso"),
                moduloid
            }
        })
            .then(response => {
                var moduloIndex = this.state.modulos.findIndex(x => x.id == moduloid);
                var _modulos = this.state.modulos;
                _modulos[moduloIndex] = response.data;

                this.setState({
                    modulos: _modulos
                });
            })
            .catch(() => {});
    };

    //calcularTotalPresencas = () => {
    //    var _modulos = this.state.modulos;
    //    var totalPresencas = 0;
    //    var totalFolhasPresencas = 0;

    //    _modulos.map(modulo => {
    //        modulo.modulo_Aula.map(aula => {
    //            aula.modulo_Aula_lvl2.map(aula2 => {
    //                if (aula2.tipo_Recurso.id === 17) {
    //                    totalFolhasPresencas = totalFolhasPresencas + 1;
    //                    var recurso = JSON.parse(aula2.recurso);

    //                    if ((!recurso.presenca_coletiva && recurso.falta_coletiva) || recurso.presencas.find(x => x === this.context.id_utilizador) < 1)
    //                        totalPresencas = totalPresencas + 1;
    //                }
    //            })
    //        })
    //    })

    //    this.setState({
    //        totalPresencas,
    //        totalFolhasPresencas
    //    })
    //}

    concluirAula = (moduloid, aulaid) => {
        axios({
            method: "post",
            url: "/api/player/concluir-aula",
            params: {
                aulaid
            }
        })
            .then(response => {
                this.listarModulo(moduloid);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível concluir o conteúdo!");
            });
    };

    render() {
        const {
            cursoid,
            curso,
            modulo_aberto,
            modulos,
            //REDIRECT
            redirect,
            redirectLink,
            ////PRESENÇAS
            //totalPresencas,
            //totalFolhasPresencas
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        return (
            <GeralContext.Consumer>
                {geralContext => {
                    return (
                        <div className="container container-body">
                            {this.state.loading ? (
                                <div className="loading-data">
                                    <div className="loading" />
                                </div>
                            ) : (
                                <div className="curso-modulos">
                                    {modulos.map((modulo, index) => (
                                        <Modulo
                                            key={index}
                                            curso={curso}
                                            cursoid={cursoid}
                                            index={index}
                                            modulo_aberto={modulo_aberto}
                                            modulo={modulo}
                                            concluirAula={this.concluirAula}
                                            disabled={modulo.estado === "BLOQUEADO" || !(modulo.modulo_Aula.length > 0)}
                                            inscrito={!geralContext.inscricao || geralContext.inscrito }
                                            subscricao={!geralContext.subscricao || geralContext.subscricaoAtiva}
                                            habilitar_gamificacao={geralContext.habilitar_gamificacao}
                                            //totalPresencas={totalPresencas}
                                            //totalFolhasPresencas={totalFolhasPresencas}
                                        />
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                }}
            </GeralContext.Consumer>
        );
    }
}

export default Modulos;
